import { useEffect, useState } from "react";

export default function useHoverCapability() {
    const [supportsHover, setSupportsHover] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;
        const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
        const update = () => setSupportsHover(mq.matches);
        update();
        mq.addEventListener?.("change", update);
        return () => mq.removeEventListener?.("change", update);
    }, []);

    return supportsHover;
}